module.exports = __webpack_public_path__ + "media/hyper/images/flags/russia-9471434c5f2ec6bc727e6286d0b8ba76.jpg";